enum ShardKeyType {
  RANGE = 'range',
  HASHED = 'hashed',
}

export default ShardKeyType;
